import classNames from "classnames";

// Types
import { WheelType } from "types/Wheel";

const { VITE_APP_PROJECT_NAME } = import.meta.env;

export const wheelSetClass = (
  value: string,
  type: WheelType,
  queue?: string,
  idle?: boolean,
) => {
  return classNames(value, {
    [`${value}__${queue}`]: !!queue,
    [`${value}_${type}`]: type,
    [`${value}_${type}_banger`]: type && VITE_APP_PROJECT_NAME === "banger",
    [`${value}_idle`]: idle,
    [`${value}__${queue}_${type}`]: !!type && !!queue,
    [`${value}__${queue}_${type}_banger`]:
      queue && type && VITE_APP_PROJECT_NAME === "banger",
    [`${value}_fast`]: !idle,
  });
};

export const setProfileClass = (
  name: string,
  element?: string,
  modifier?: string,
  flag?: boolean,
) => {
  return classNames(name, {
    [`${name}__${element}`]: flag,
    [`${name}_${modifier}`]: flag,
    [`${name}__${element}_${modifier}`]: flag,
  });
};
